export default __webpack_public_path__ + "static/media/error500.f1f8aa2e.svg";